import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import './Profile.css';


import ScrollService from "../../../utilities/ScrollService";
import Animations from "../../../utilities/Animations";

function Profile(props) {
  const [typeEffect] = useTypewriter({
    words: ["prava?", "IT-a?", "marketinga?"],
    loop: {},
    typeSpeed: 100,
    deleteSpeed: 40,
  });

  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;

    Animations.animations.fadeInScreen(props.id);
  };

  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  return (
    <div className="profile-container">
      <div className="profile-parent">
        <div className="profile-details">
          <div className="colz">
            <div className="colz-icon">
            <a href="https://www.facebook.com/profile.php?id=61573389059672">
              <i className="fa fa-facebook-square"></i>
            </a>
            <a href="https://www.instagram.com/magna.doo/">
              <i className="fa fa-instagram"></i>
            </a>
            </div>
          </div>
          <div className="profile-details-name">
            <span className="primary-text">
              {" "}
              Mi smo <span className="highlighted-text">MAGNA</span>
            </span>
          </div>
          <div className="profile-details-role">
            <span className="primary-text">
              {" "}
              <h1>Trebate usluge iz {" "}
                <span>{typeEffect}</span>
              </h1>
              <span className="profile-role-tagline">
                Posvetite se isključivo svom poslu, sve ostalo prepustite nama.
              </span>
            </span>
          </div>
          <div className="profile-options">
            <button className="btn primary-btn" 
            onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
            >
              {""}
              Kontakt{" "}
            </button>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background">

          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
